import { ITramite } from "../ioip/sdk/base";

export interface IAppContext {
    AllowedExtensions: string;
    B2C: { IsEnabled: boolean; Authority: string; ClientId: string; Scopes: string; }
    Domain: string;
    EnableContactProfession: boolean;
    EnableContactRequesterType: boolean;
    FechaConsultaSolicitudes: string;
    InformacionSolicitudAnonima: string;
    IsAffiliatedEntitiesEnabled: boolean;
    IsAnonymousRequestsEnabled: boolean;
    IsDocumentVerificationEnabled: boolean;
    LeyHabeasData: string;
    MaxFileSize: number;
    MensajeErrorCrearSolicitud: string;
    PoliticaPrivacidad: string;
    PoliticaTratamientoDatosPersonales: string;
    ProcesoxUrl: string;
    EnabledSubjectDescription: boolean;
    EnableCommentsField: boolean;
    SubjectMaxLength: number;
    Tramites: ITramite[];
    ReCaptchaSiteKey: string;
    InformacionSolicitudAutenticado: string;
    EnableRiskField: boolean;
    SubjectRiskField: string;
    ConfirmMessage: string;
    ToolTipFieldWord: string;
    ToolTipFieldType: string;
    ShowSectionField: boolean;
    NameSectionField: string;
    TextInformation: string;
}

export const defaultIAppContext = (): IAppContext => {
    return {
        AllowedExtensions: '',
        B2C: { Authority: '', ClientId: '', IsEnabled: false, Scopes: '' },
        Domain: '',
        EnableContactProfession: false,
        EnableContactRequesterType: false,
        FechaConsultaSolicitudes: '',
        InformacionSolicitudAnonima: '',
        IsAffiliatedEntitiesEnabled: false,
        IsAnonymousRequestsEnabled: false,
        IsDocumentVerificationEnabled: false,
        LeyHabeasData: '',
        MaxFileSize: 0,
        MensajeErrorCrearSolicitud: '',
        PoliticaPrivacidad: '',
        PoliticaTratamientoDatosPersonales: '',
        ProcesoxUrl: '',
        EnabledSubjectDescription: true,
        EnableCommentsField: false,
        SubjectMaxLength: 0,
        Tramites: [],
        ReCaptchaSiteKey: '',
        InformacionSolicitudAutenticado: '',
        EnableRiskField: false,
        SubjectRiskField: '',
        ConfirmMessage: '',
        ToolTipFieldWord: '',
        ToolTipFieldType: '',
        ShowSectionField: false,
        NameSectionField: 'Dependencia',
        TextInformation: ''
    };
}